import { render, staticRenderFns } from "./AccountTotal.vue?vue&type=template&id=228e7ed8&scoped=true"
import script from "./AccountTotal.vue?vue&type=script&lang=js"
export * from "./AccountTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e7ed8",
  null
  
)

export default component.exports